import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { TDashboardGroupResponse } from 'types/GlobalDashboardGroup'
import { TReport } from 'types/GlobalReport'

const selectByKeyMetricId = (state: ApplicationState) =>
  state.ResourceKeyMetricLinkerStore.byKeyMetricId

const selectDashboardGroups = (state: ApplicationState) =>
  state.DashboardGroupStore.data

const selectReports = (state: ApplicationState) => state.ReportStore.reports

export const selectResourceKeyMetricLinkerByKeyMetricId = createSelector(
  [selectByKeyMetricId, selectDashboardGroups, selectReports],
  (
    byKeyMetricId,
    dashboardGroups,
    reports
  ): Record<string, (TDashboardGroupResponse | TReport)[]> => {
    const result: Record<string, (TDashboardGroupResponse | TReport)[]> = {}

    Object.entries(byKeyMetricId).forEach(([kmId, resourceEntries]) => {
      result[kmId] = resourceEntries
        .map(({ id, type }) =>
          type === 'report' ? reports[id] : dashboardGroups[id]
        )
        .filter(Boolean) as (TDashboardGroupResponse | TReport)[]
    })

    return result
  }
)

export const selectResourcesForKeyMetric = createSelector(
  [
    selectByKeyMetricId,
    selectDashboardGroups,
    selectReports,
    (_: ApplicationState, keyMetricId: string) => keyMetricId
  ],
  (
    byKeyMetricId,
    dashboardGroups,
    reports,
    keyMetricId
  ): (TDashboardGroupResponse | TReport)[] => {
    const resourceEntries = byKeyMetricId[keyMetricId] || []

    return resourceEntries
      .map(({ id, type }) =>
        type === 'report' ? reports[id] : dashboardGroups[id]
      )
      .filter(Boolean) as (TDashboardGroupResponse | TReport)[]
  }
)
